import React, {PureComponent} from 'react'
import { Route, Switch } from 'react-router-dom'
import QuestionsPage from '../containers/questions-page'
import ParametersPage from '../containers/parameters-page'
import LandingPage from '../containers/landing-page'
import StatisticsPageThemes from '../containers/statistics-page-themes'
import StatisticsPageDetails from "../containers/statistics-page-theme"
import StatisticsPageDrivers from '../containers/statistics-page-drivers'
import StatisticsPageQuestions from '../containers/statistics-page-openquestions'
import StatisticsPageStatements from '../containers/statistics-page-statements'
import StatisticsPageComparativeReports from '../containers/statistics-page-comparative-reports'
import SummaryPage from '../containers/summary-page'
import ProgressReports from '../containers/progress-reports'
import CatalystPage from '../containers/catalyst-page'
import DialoguePage from '../containers/dialogue-page'
import DialoguePageTopic from '../containers/dialogue-page-topic'
import Helmet from 'react-helmet'
import { setSurveyLanguages } from '../actions/survey'
import { connect } from 'react-redux'

const mapStateToProps = ({ survey: { surveyLanguages } }) => {
  return {
    surveyLanguages
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onSetSurveyLanguages: (surveyLanguages) => {
      dispatch(setSurveyLanguages(surveyLanguages));
    },
  };
};

class Application extends PureComponent {

  render() {
    const {
      match: {
        url,
        path,
        params: {
          languageCode
        }
      },
      location: {
        pathname
      },
      questionnaire: {
        languages
      },
      surveyLanguages,
      onSetSurveyLanguages
    }
     = this.props

    /* If languages are not defined (old surveys) we add english to the languages */
    let appLanguages = languages ? (languages.length > 0 ? languages : ['en']) : ['en'];

    /* Update the app state */
    if(surveyLanguages.toString() !== appLanguages.toString()) {
      onSetSurveyLanguages(appLanguages)
    }

    /* Accepted languages are those which are selected in admin */
    /* If languageCode is not in the accepted, we can redirect to the first language */

    if (!appLanguages.includes(languageCode)) {
      const toReplace = "/" + languageCode + "/"
      const newUrl = pathname.replace(toReplace, `/${appLanguages[0]}/`)
      this.props.history.push(newUrl)
    }

    /* Update the html language */
    document.documentElement.lang = languageCode;

    return (
      <div className="app">
        <Helmet defaultTitle={"Engager"} titleTemplate={"Engager"}>
          <link rel="canonical" href={`${process.env.PUBLIC_URL}${url}`} />
          <body />
        </Helmet>
        <Switch>
          <Route
            path={`${path}/:page(background)`}
            component={ParametersPage}
          />
          <Route
            path={`${path}/:page(catalyst)/:catalystId/:questions`}
            component={QuestionsPage}
          />
          <Route
            path={`${path}/:page(catalyst)/:catalystId`}
            component={CatalystPage}
          />
          <Route
            path={`${path}/:page(finish)/dialogue/topic/:topicId`}
            component={DialoguePageTopic}
          />
          <Route
            path={`${path}/:page(finish)/dialogue`}
            component={DialoguePage}
          />
          <Route
            path={`${path}/:page(finish)/:catalystId/details/:parameterValue?`}
            component={StatisticsPageDetails}
          />
          <Route
            path={`${path}/:page(finish)/drivers/:parameterValue?`}
            component={StatisticsPageDrivers}
          />
          <Route
            path={`${path}/:page(finish)/statements/:parameterValue?`}
            component={StatisticsPageStatements}
          />
          <Route
            path={`${path}/:page(finish)/open-questions/:parameterValue?`}
            component={StatisticsPageQuestions}
          />
          <Route
            path={`${path}/:page(finish)/comparative-reports/`}
            component={StatisticsPageComparativeReports}
          />
          <Route
            path={`${path}/:page(finish)/themes`}
            component={StatisticsPageThemes}
          />
          <Route
            path={`${path}/:page(finish)/progress-reports`}
            component={ProgressReports}
          />
          <Route
            path={`${path}/:page(finish)`}
            component={SummaryPage}
          />
          <Route
            path={`${path}`}
            component={LandingPage}
          />
          <Route
            component={() => <h1>404</h1>}
          />
        </Switch>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Application)



// WEBPACK FOOTER //
// ./src/components/application.js